<template>
  <div style="height:100%;background:#ededed">
    <div class="contain hed100">

      <div class="nav-check-list"
           style="position: fixed;top:0;left: 0;z-index: 11;">

        <!-- <input type="text"
                 placeholder="请输入客户中文名称"
                 class="text-addvisit"
                 v-model="keyWord"
                 ><span style="padding-left:0.1rem"
                ><img src="../../assets/images/icon-search.png"></span> -->
        <van-search v-model="keyWord"
                    placeholder="请输入客户名称"
                    show-action
                    shape="round"
                    @search="onSeacrh">
          <div slot="action"
               @click="onSeacrh"><van-button plain
                    type="info"
                    style="width:1.54rem;height:0.54rem;padding:0.1rem;margin-right:0.24rem;font-size:0.24rem;
                    align-content:end;float: right;"
                    >搜索</van-button></div>
        </van-search>
        <van-button plain
                    type="info"
                    style="width:1.54rem;height:0.54rem;padding:0.1rem;margin-right:0.24rem;font-size:0.24rem;
                    align-content:end;float: right;"
                    @click="turnToHome">首页</van-button>
      </div>
      <scroller :on-infinite="infinite"
                :on-refresh="refresh"
                :noDataText="noDataText"
                ref="my_scroller"
                v-if="planArr.length>0">
        <div class="layout-checklist">
          <VisitPlanItem :item="item"
                         v-for="item in planArr"
                         :key="item.id"></VisitPlanItem>
        </div>
      </scroller>
      <div class="content-btn-check">
        <button class="del-desc-check btnCenter widthmax"
                @click="createNewVisitPlan">创建新访问计划</button>
      </div>
      <div class="layout-checklist null-checklist"
           v-if="planArr.length==0">
        <img src="../../assets/images/img-null.png"
             class="img-null">
        <p class="color-gray">暂无数据</p>
      </div>

    </div>

  </div>
</template>

<script>
import visitPlanModel from '../../api/model/visit-plan'
import VisitPlanItem from '../../components/visit-plan/VisitPlanItem.vue'
export default {
  name: 'VisitPlanList',
  data() {
    return {
      noDataText: '没有数据了',
      planArr: [],
      pageIndex: 1,
      pageSize: 20,
      selected: 'nac-nav-checklist',
      keyWord: '',
    }
  },
  components: {
    VisitPlanItem,
  },
  methods: {
    createNewVisitPlan() {
      this.$router.push('/visitPlanInfo/0')
    },
    async getData() {
      const res = await visitPlanModel.getVisitPlanPageList({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        keyWord:this.keyWord
      })
      if (res.success) {
        res.data.forEach((element) => {
          this.planArr.push(element)
        })
      } else {
        this.$toast(res.msg)
      }
    },

    infinite: function () {
      this.pageIndex++
      this.$refs.my_scroller.finishInfinite(false)
      this.getData()
      this.$refs.my_scroller.finishInfinite(true)
    },
    refresh: function () {
      this.planArr = []
      this.pageIndex = 1
      this.getData()
      this.$refs.my_scroller.finishPullToRefresh()
    },
    turnToHome() {
      this.$router.push('/home')
    },
    onSeacrh(){
      this.refresh()
    }
  },
  mounted() {
    this.getData()
  },
}
</script>

<style scoped>
</style>